import type { FC } from 'react';
import Link from 'next/link';
import { PlayCircleOutline } from '@eqi-investimentos/icons/web';
import { Flex, Progress, Text } from '@eqi-investimentos/react';

const ContainerComponent: FC<
  Omit<CardHorizontalContentItemProps, 'href' | 'target'>
> = ({ duration, progress, title, onClick = () => null }) => {
  return (
    <Flex
      onClick={onClick}
      alignItems="center"
      justifyContent="space-between"
      pb="l"
      w="full"
      borderBottomWidth="1px"
      borderBottomColor="border.secondary"
      cursor="pointer"
    >
      <Flex gap="xs" alignItems="center">
        <PlayCircleOutline boxSize="2rem" color="content.brand" />
        <Text size="xl">{title}</Text>
      </Flex>
      <Flex gap="m" alignItems="center">
        <Text size="l" color="content.secondary">
          {duration}
        </Text>
        <Progress value={progress} w="20rem" size="sm" />
      </Flex>
    </Flex>
  );
};

const WithLink = ({
  href = '',
  target = '_self',
  ...props
}: CardHorizontalContentItemProps) => (
  <Flex as={Link} href={href} target={target} passHref prefetch w="full">
    <ContainerComponent {...props} />
  </Flex>
);

export const CardHorizontalContentItem = ({
  href,
  ...props
}: CardHorizontalContentItemProps) =>
  href ? (
    <WithLink href={href} {...props} />
  ) : (
    <ContainerComponent {...props} />
  );

type CardHorizontalContentItemProps = {
  duration: string;
  progress: number;
  title: string;
  href?: string;
  target?: string;
  onClick?: () => void;
};
